export default class WorkArchive {

	// Properties
	// =========================================================================

	archive = null;
	list = null;
	img = null;
	items = null;
	mousePos = { x: 0, y: 0 };

	constructor () {
		this.archive = document.getElementById('workArchive');

		if (!this.archive)
			return;

		this.img = this.archive.getElementsByTagName('img')[0];
		this.list = this.archive.getElementsByTagName('ul')[0];
		this.items = this.archive.getElementsByTagName('a');

		document.addEventListener('mousemove', this.onMouseMove);
		this.list.addEventListener('mouseenter', this.onMouseEnter);
		this.list.addEventListener('mouseleave', this.onMouseLeave);

		for (let i = 0, l = this.items.length; i < l; ++i)
			this.items[i].addEventListener(
				'mouseenter',
				this.onItemMouseEnter.bind(this, this.items[i])
			);

		requestAnimationFrame(this.render);
	}

	deconstructor () {
		if (!this.archive)
			return;

		document.removeEventListener('mousemove', this.onMouseMove);
		this.list.removeEventListener('mouseenter', this.onMouseEnter);
		this.list.removeEventListener('mouseleave', this.onMouseLeave);
	}

	// Actions
	// =========================================================================

	render = () => {
		this.img.style.setProperty(
			'--work-archive-img-top',
			this.mousePos.y + 'px'
		);

		const iw = this.img.getBoundingClientRect().width / 2;
		let x = this.mousePos.x;

		if (x + iw > window.innerWidth)
			x = window.innerWidth - iw;
		else if (x - iw < 0)
			x = iw;

		this.img.style.setProperty(
			'--work-archive-img-left',
			x + 'px'
		);

		requestAnimationFrame(this.render);
	};

	// Events
	// =========================================================================

	onMouseMove = e => {
		let x = 0,
		    y = 0;

		if (!e) e = window.event;

		if (e.pageX || e.pageY) {
			x = e.pageX;
			y = e.pageY;
		} else if (e.clientX || e.clientY) {
			x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
			y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
		}

		this.mousePos = { x, y };
	};

	onMouseEnter = () => {
		this.img.classList.add('visible');
	};

	onMouseLeave = () => {
		this.img.classList.remove('visible');
	};

	onItemMouseEnter = item => {
		this.img.setAttribute('src', item.dataset.src);
		this.img.setAttribute('srcset', item.dataset.srcset);
	};

}